// extracted by mini-css-extract-plugin
export var chefImg = "styles-mod--chef-img--e2087";
export var cookingHub = "styles-mod--cooking-hub--65d04";
export var text = "styles-mod--text--f0e3c";